<table class="subwindow" [cdkDragConstrainPosition]="constrainPosition" plessTitleWindowSub cdkDrag [windowMovable]="false" [windowResizable]="false">
  <tr class="subwindow-title" cdkDragHandle>
    <th class="window-title-name">予約商品設定</th>
  </tr>
  <tr class="subwindow-body">
    <td>
      <div class="contents-area" (dragstart)="onDragstartBody($event)">
        <div class="element-column">
          <div class="block-row">
            <div class="column-list">
              <label class="list-input-title">配達企画回</label>
              <div class="list-input-content">
                <app-catalog-text-with-order #txti_DeliveryCatalog [autofocus]="true" [tabindex]="0"
                  [(ngModel)]="kymw0906Model.deliveryCatalog" class="deliv-catalog text-label-required"
                  [tabindex]="0" forcedEnabledMode="" plessInputTextSub [required]="true"
                  [maxlength]="8" (change)="common_CHANGEHandler()"
                  (focusout)="eventDelivCatalog_FOCUS_OUTHandler()"
                  (onChangedOrderCode)="kymw0906Model.deliveryOrderCode = $event" [disabled]="isReadOnlyMode()">
                </app-catalog-text-with-order>
              </div>
              <label class="list-input-title">注文コード割当</label>
              <div class="list-input-content">
                <app-versatile-combo-box
                  [(ngModel)]="kymw0906Model.preOrderNumQuotaCode" [listSource]="kymw0906Model.preOrderOrderNumQuotaCodeList"
                  valueField="OrderNumQuotaCode" labelField="OrderNumQuotaCodeName" [blank]="true" [blankVal]="''" [tabindex]="0" [visible]="true"
                  [autofocus]="false" forcedEnabledMode="true" (change)="common_CHANGEHandler();preOrderNumQuotaCode_CHANGEHandler()" [required]="true"
                  [style.width.rem]="17" [disabled]="isReadOnlyMode()">
                </app-versatile-combo-box>
              </div>
            </div>
            <div class="column-list">
              <label class="list-input-title">アイテムコード</label>
              <div class="list-input-content">
                <select #cmb_ItemCode id="cmb_ItemCode" class="combo-box-required" forcedEnabledMode="None" tabindex="0" [style.width.px]="175"
                  [disabled]="isDetailMode() || isReadOnlyMode()" [(ngModel)]="kymw0906Model.selectedItemCode" (change)="eventItemCode_CHANGEHandler();common_CHANGEHandler()">
                  <option value=""></option>
                  <ng-template ngFor let-item [ngForOf]="kymw0906Model.itemCodeList">
                    <option value="{{item.ItemCode}}">{{item.ItemCode}}</option>
                  </ng-template>
                </select>
              </div>
              <label class="list-input-title">注文コード</label>
              <div class="list-input-content">
                <input type="text" id="txti_OrderNum" readonly [ngModel]="kymw0906Model.orderNum">
              </div>
            </div>
          </div>
          <div>
            <div class="column-list">
              <label class="list-input-title">配達企画曜日</label>
              <div class="list-input-content">
                <app-checkbox-label #chk_DelivMonday [label]="'月'" id="chk_DelivMonday" [subid]="'chk_DelivMonday'" [tabindex]="0"
                  [(ngModel)]="kymw0906Model.delivMonday" (change)="eventPreOrderDetailListChkMonday_CLICKHandler();common_CHANGEHandler()" [disabled]="isReadOnlyMode()">
                </app-checkbox-label>
                <app-checkbox-label #chk_DelivTuesday [label]="'火'" id="chk_DelivTuesday" [subid]="'chk_DelivTuesday'" [tabindex]="0"
                  [(ngModel)]="kymw0906Model.delivTuesday" (change)="eventPreOrderDetailListChkTuesday_CLICKHandler();common_CHANGEHandler()" [disabled]="isReadOnlyMode()">
                </app-checkbox-label>
                <app-checkbox-label #chk_DelivWednesday [label]="'水'" id="chk_DelivWednesday" [subid]="'chk_DelivWednesday'" [tabindex]="0"
                  [(ngModel)]="kymw0906Model.delivWednesday" (change)="eventPreOrderDetailListChkWednesday_CLICKHandler();common_CHANGEHandler()" [disabled]="isReadOnlyMode()">
                </app-checkbox-label>
                <app-checkbox-label #chk_DelivThursday [label]="'木'" id="chk_DelivThursday" [subid]="'chk_DelivThursday'" [tabindex]="0"
                  [(ngModel)]="kymw0906Model.delivThursday" (change)="eventPreOrderDetailListChkThursday_CLICKHandler();common_CHANGEHandler()" [disabled]="isReadOnlyMode()">
                </app-checkbox-label>
                <app-checkbox-label #chk_DelivFriday [label]="'金'" id="chk_DelivFriday" [subid]="'chk_DelivFriday'" [tabindex]="0"
                  [(ngModel)]="kymw0906Model.delivFriday" (change)="eventPreOrderDetailListChkFriday_CLICKHandler();common_CHANGEHandler()" [disabled]="isReadOnlyMode()">
                </app-checkbox-label>
              </div>
            </div>
          </div>
          <div>
            <div class="block-row">
              <div class="column-list">
                <label class="list-input-title">専用商品名</label>
                <div class="list-input-content">
                  <app-not-null-text-input-coop-deli #txti_PreOrderGoodsName id="txti_PreOrderGoodsName"
                    [subid]="'txti_PreOrderGoodsName'" [required]="true" [maxChars]="15" [restrict]="'[ -￮]'"
                    [tabindex]="0" [fullOnly]="true" [(ngModel)]="kymw0906Model.preOrderGoodsName"
                    [forcedEnabledMode]="'none'" [displayCountField]="false" [style.width.rem]="17" (change)="common_CHANGEHandler()" [disabled]="isReadOnlyMode()">
                  </app-not-null-text-input-coop-deli>
                </div>
                <label class="list-input-title">専用規格名</label>
                <div class="list-input-content">
                  <app-not-null-text-input-coop-deli #txti_PreOrderStandardName id="txti_PreOrderStandardName"
                    [subid]="'txti_PreOrderStandardName'" [required]="true" [maxChars]="10" [restrict]="'[ -￮]'"
                    [tabindex]="0" [fullOnly]="true" [(ngModel)]="kymw0906Model.preOrderStandardName"
                    [forcedEnabledMode]="'none'" [displayCountField]="false" [style.width.rem]="12" (change)="common_CHANGEHandler()" [disabled]="isReadOnlyMode()">
                  </app-not-null-text-input-coop-deli>
                </div>
                <label class="list-input-title">値引区分</label>
                <div class="list-input-content">
                  <app-versatile-combo-box #cmb_DiscountType [(ngModel)]="kymw0906Model.discountType" [listSource]="kymw0906Model.discountTypeList"
                    valueField="Code" [width]="120" labelField="Name" [required]="true" [tabindex]="0" [dspBothField]="true"
                    [visible]="true" [autofocus]="false" [forcedEnabledMode]="'none'" (change)="discountType_CHANGEHandler();common_CHANGEHandler()" [disabled]="isReadOnlyMode()">
                  </app-versatile-combo-box>
                </div>
                <label class="list-input-title">値引率</label>
                <div class="list-input-content">
                  <app-not-null-text-input #txti_DiscountRate id="txti_DiscountRate" [subid]="'txti_DiscountRate'"
                    type="text" [maxChars]="3" [displayCountField]="false" [forcedEnabledMode]="'none'"
                    [restrict]="'[0-9]'" [tabindex]="0" [halfOnly]="true" [disabled]="kymw0906Model.discountType==='1' || kymw0906Model.discountType==='0' || isReadOnlyMode()"
                    [(ngModel)]="kymw0906Model.discountRate" [style.width.rem]="3" (change)="eventDiscountRate_CHANGEHandler();common_CHANGEHandler()">
                  </app-not-null-text-input>
                </div>
                <label class="list-input-title">値引前供給単価</label>
                <div class="list-input-content">
                  <app-not-null-text-input #txti_SupplyPrice id="txti_SupplyPrice" [subid]="'txti_SupplyPrice'"
                    type="text" [maxChars]="7" [displayCountField]="false" [forcedEnabledMode]="'none'"
                    [restrict]="'[0-9]'" [tabindex]="0" [disabled]="isReadOnlyMode()"
                    [(ngModel)]="kymw0906Model.supplyPriceStandard" [style.width.rem]="7" [halfOnly]="true" (change)="eventSupplyPrice_CHANGEHandler();common_CHANGEHandler()">
                  </app-not-null-text-input>
                </div>
                <label class="list-input-title">価格パターン</label>
                <div class="list-input-content" style="width: 100px;">
                  <app-code-combo-box #cmb_PricePattern id="cmb_PricePattern" [subid]="'cmb_PricePattern'"
                    [tabindex]="0" [required]="true" [codeDiv]="'ct355'" [labelField]="'codeValueName'"
                    class="combo-box-required" [forcedEnabledMode]="'none'" [disabled]="isReadOnlyMode()" [blank]="false"
                    [(ngModel)]="this.kymw0906Model.pricePattern" (change)="pricePattern_CHANGEHandler()">
                  </app-code-combo-box>
                </div>
              </div>
              <div class="column-list">
                <label class="list-input-title">専用商品名(カナ)</label>
                <div class="list-input-content">
                  <app-not-null-text-input #txti_PreOrderGoodsNameKana [required]="true"
                    id="txti_PreOrderGoodsNameKana" [subid]="'txti_PreOrderGoodsNameKana'" [maxChars]="15"
                    [restrict]="'[ -￮]'" [forcedEnabledMode]="'none'" [toUpperCase]="true" [tabindex]="0"
                    [(ngModel)]="kymw0906Model.preOrderGoodsNameKana" [halfOnly]="true"
                    class="disabled-color-disabled" [displayCountField]="false" [style.width.rem]="17" (change)="common_CHANGEHandler()" [disabled]="isReadOnlyMode()" (input)="eventPreOrderGoodsNameKana_deleteCommaHandler()"
                    (compositionstart)="onCompStart()" (compositionend)="onCompDeleteCommaEnd($event)">
                  </app-not-null-text-input>
                </div>
                <label class="list-input-title">専用規格名(カナ)</label>
                <div class="list-input-content">
                  <app-not-null-text-input #txti_PreOrderStandardNameKana [required]="true"
                    id="txti_PreOrderStandardNameKana" [subid]="'txti_PreOrderStandardNameKana'" [maxChars]="10"
                    [restrict]="'[ -￮]'" [forcedEnabledMode]="'none'" [toUpperCase]="true" [tabindex]="0"
                    [(ngModel)]="kymw0906Model.preOrderStandardNameKana" [halfOnly]="true"
                    class="disabled-color-disabled" [displayCountField]="false" [style.width.rem]="12" (change)="common_CHANGEHandler()" [disabled]="isReadOnlyMode()" (input)="eventPreOrderStandardNameKana_deleteCommaHandler()"
                    (compositionstart)="onCompStart()" (compositionend)="onCompDeleteCommaEnd($event)">
                  </app-not-null-text-input>
                </div>
                <label class="list-input-title">セット企画</label>
                <div class="list-input-content">
                  <input type="checkbox" #chk_SetPreOrderType id="chk_SetPreOrderType" forcedEnabledMode="none" [tabindex]="0"
                    [(ngModel)]="kymw0906Model.setPreOrderType" (change)="common_CHANGEHandler()" [disabled]="isReadOnlyMode()"/>
                </div>
                <label class="list-input-title">値引単価</label>
                <div class="list-input-content">
                  <app-not-null-text-input #txti_DiscountUnitPrice id="txti_DiscountUnitPrice" [subid]="'txti_DiscountUnitPrice'"
                    type="text" [maxChars]="7" [displayCountField]="false" [forcedEnabledMode]="'none'"
                    [restrict]="'[0-9]'" [tabindex]="0" [disabled]="kymw0906Model.discountType==='2' || kymw0906Model.discountType==='0' || isReadOnlyMode()"
                    [(ngModel)]="kymw0906Model.discountUnitPrice" [style.width.rem]="7" [halfOnly]="true" (change)="eventDiscountUnitPrice_CHANGEHandler();common_CHANGEHandler()">
                  </app-not-null-text-input>
                </div>
                <label class="list-input-title">値引後供給単価</label>
                <div class="list-input-content">
                  <input #txti_RelationPcodeOld type="text" readonly id="txti_DiscountSupplyUnitPrice"
                    forcedEnabledMode="none" plessInputTextSub [style.width.rem]="7"
                    [restrict]="'[ -￮]'" [(ngModel)]="kymw0906Model.discountSupplyUnitPrice"/>
                </div>
                <label class="list-input-title">ポイント数</label>
                <div class="list-input-content">
                  <app-text-input #txti_PreOrderPoints id="txti_PreOrderPoints" [subid]="'txti_PreOrderPoints'"
                    type="text" [maxChars]="7" [displayCountField]="false" [forcedEnabledMode]="'none'"
                    [restrict]="'[0-9]'" [tabindex]="0" [halfOnly]="true"
                    [(ngModel)]="kymw0906Model.preOrderPoints" [style.width.rem]="7" (change)="common_CHANGEHandler()" [disabled]="isReadOnlyMode()">
                  </app-text-input>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <wj-flex-grid #dtg_GoodsPlanNumList id="dtg_GoodsPlanNumList" [itemsSource]="kymw0906Model.goodsPlanNumList" [isReadOnly]="true"
            style="width: 285px;" [allowSorting]="false" [headersVisibility]="'Column'" [allowDragging]="'None'" [selectionMode]="'Row'">
            <wj-flex-grid-column [minWidth]="5" [width]="40" [binding]="''" [header]="' '" [align]="'center'">
              <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                <div *ngIf="cell.item.coopName !== '合計'">
                  <input type="checkbox" [tabindex]="-1" (mouseup)="$event.stopPropagation()" 
                    [(ngModel)]="cell.item.checked" id="goods_plan_num_list_check_{{cell.row.index}}"
                    (change)="eventGoodsPlanNumListChk_CLICKHandler(cell.row.index);common_CHANGEHandler()" [disabled]="cell.item.disabled || isReadOnlyMode()"/>
                </div>
              </ng-template>
              <ng-template wjFlexGridCellTemplate [cellType]="'ColumnHeader'" let-cell="cell">
                <div class="goods_plan_num_list_all_check">
                  <input type="checkbox" id="chk_goods_plan_num_list_all_check" #chk_goods_plan_num_list_all_check forcedEnabledMode="true" [tabindex]="0"
                    (change)="eventGoodsPlanNumListAll_CLICKHandler();common_CHANGEHandler()" [(ngModel)]="kymw0906Model.goodsPlanNumListEnableFlgAll"
                    class="header-checkbox all-target_list-checkbox" [disabled]="isDisabledAllCoop() || isReadOnlyMode()"/>
                </div>
              </ng-template>
            </wj-flex-grid-column>
            <wj-flex-grid-column [header]="'会員生協'" [minWidth]="5" [width]="105" [binding]="'coopName'"></wj-flex-grid-column>
            <wj-flex-grid-column [header]="'計画数'" [minWidth]="5" [width]="120" [binding]="'planNum'" [align]="'right'" [isReadOnly]="true">
              <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                <input type="text" *ngIf="cell.item.coopName !== '合計'" plessInputTextSub [restrict]="'[0-9]'" [maxlength]="8" [halfOnly]="true" [style.width.%]="'100'" [(ngModel)]="cell.item.planNum" class="text-label-required"
                  (change)="planNumAiPrediction_CHANGEHandler();common_CHANGEHandler()" [disabled]="cell.item.disabled || !cell.item.checked || isReadOnlyMode()" style="text-align:right;"/>
                <input type="text" *ngIf="cell.item.coopName === '合計'" plessInputTextSub [restrict]="'[0-9]'" [halfOnly]="true" [style.width.%]="'100'" [(ngModel)]="cell.item.planNum"
                  style="text-align:right; background-color: rgba(0,0,0,0);" readonly/>
              </ng-template>
            </wj-flex-grid-column>
          </wj-flex-grid>
        </div>
      </div>
    </td>
  </tr>

  <tfoot cdkDragHandle>
    <tr>
      <td>
        <div class="footer-buttons">
          <button id="btn_Set" forcedEnabledMode="" class="btn-primary" (click)="eventSet_CLICKHandler()" [disabled]="isReadOnlyMode()"
            [tabindex]="0">設定</button>
        </div>
        <div class="window-title-close">
          <button [tabindex]="0" (click)="eventClose_CLICKHandler()"></button>
        </div>
      </td>
    </tr>
  </tfoot>
</table>
